module.exports = __webpack_public_path__ + "static/media/AthleteFeeds.622bc841.jpg";